import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DeliverabilityPage } from "@/features/outreach/DeliverabilityPage";

const search = z.object({
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/outreach/deliverability")({
  validateSearch: search,
  component: () => <DeliverabilityPage search={Route.useSearch()} />,
});
